import styles from "./AboutContent.module.css";
import BenWesson from "./BenWessonPortfolioHeadShot.jpg";
export default function AboutContent() {
	return (
		<div className={styles.about}>
			<div className={styles.header}>
				<h1 className={styles.message}>
					Hi I'm <span className={styles.name}>Ben Wesson</span>
					
				</h1>
				<img
					className={styles.image}
					src={BenWesson}
					alt="Portrait of Ben Wesson"
				/>
				
			</div>
			

			<p className={styles.text}>
				I am a web developer based in the DMV, building fullstack apps
				with React, Next.js and TypeScript. I have experience with
				collaborative software development and project design. I am
				passionate about improving my skills and exploring the world of
				software.
			</p>

			<div className={styles.links}>
				<a
					className={styles.link}
					href="https://www.linkedin.com/in/bwesson/"
				>
					LinkedIn
				</a>
				<a className={styles.link} href="https://github.com/benwesson">
					GitHub
				</a>
			</div>

			

			{/* <NavLink to="/projects" className={styles.button}>
				See Projects
			</NavLink> */}
		</div>
	);
}
